export default function (Component) {
    Component.options.tsv = [{"label":"South Dakota","value":81},{"label":"Florida","value":37},{"label":"Delaware","value":35},{"label":"Texas","value":24},{"label":"Nevada","value":14}]
  }